<template>
  <div
    v-if="giftCard"
    v-element-loader="{ endpoint: 'giftCard' }"
    class="gift-card-container__main"
    :style="{'background-image': `url(${t('pdfImage')})`}">
    <div class="gift-card-container__content">
      <h1 class="container__header">
        {{ t('giftCardPageHeader') }}
      </h1>
      <p v-if="giftCard.errorMessage" class="gift-card-container__validation">
        {{ giftCard.errorMessage }}
      </p>
      <template v-else>
        <dl class="gift-card-container__info">
          <div>
            <dt>{{ t('valueLabel') }}</dt>
            <dd>{{ giftCard.amount }} {{ giftCard.currency }}</dd>
          </div>
          <div>
            <dt>{{ t('codeLabel') }}</dt>
            <dd>{{ giftCard.code }}</dd>
          </div>
          <div>
            <dt>{{ t('validUntilLabel') }}</dt>
            <dd>{{ giftCard.validUntil }}</dd>
          </div>
        </dl>
        <div v-if="giftCard.isValid">
          <div class="gift-card-container__actions">
            <oie-base-action
              size="large"
              @click="printGiftCard()">
              {{ t('printLabel') }}
              <template #iconAppend>
                <oie-base-icon size="s" icon="pdf"></oie-base-icon>
              </template>
            </oie-base-action>
            <oie-base-action
              size="large"
              theme="outlined"
              @click="copyToClipboard(giftCard.code)">
              {{ t('copyToClipboardLabel') }}
              <template #iconAppend>
                <oie-base-icon size="s" icon="copy"></oie-base-icon>
              </template>
            </oie-base-action>
          </div>
        </div>
        <p v-else class="gift-card-container__validation">
          {{ giftCard.validationMessage }}
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    giftCardToken: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      giftCard: null
    //   giftCard: {
    //     'errorMessage': null,
    //     'code': 'EA7J-MYND-SK5G-RRS8',
    //     'currency': 'SEK',
    //     'validUntil': '2025-11-20',
    //     'amount': 5000,
    //     'balance': 100,
    //     'isValid': true,
    //     'validationMessage': null,
    //     'pdfImageUrl': null }
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.getGiftCard()
  },
  methods: {
    getGiftCard() {
      httpService.get(`giftcard?token=${this.giftCardToken}&email=${this.email}`).then(res => {
        this.giftCard = res.data
      })
    },
    copyToClipboard(value) {
      navigator.clipboard.writeText(value)
    },
    printGiftCard() {
      // window.print()
      window.open(`/mvcapi/se/sv/giftcard/pdf?token=${this.giftCardToken}`, '_blank')
    }
  }
}
</script>

<style lang="scss">
.gift-card-container__main {
  padding: measure(full);
  margin: 0 auto;
  background-color: color(background-blue);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;

  @include media('small'){
    margin: measure(quarter) auto;
  }

  @include media('medium'){
    margin: measure(double) auto;
    padding: measure(double);
  }
}

.gift-card-container__content {
  padding: measure(half);
  border: 1px solid color(border-gray);
  background-color: rgba(255, 255, 255, 0.9);
  flex: 0 1 50rem;
  text-align: center;
}

.container__header {
  @include h1-bold();
}

.gift-card-container__info {
  @include h3();
}

.gift-card-container__info dd{
  @include h2-bold();
}

.gift-card-container__validation {
  margin-top: measure(half);
  color: color(text-red);
}

.gift-card-container__info > div:not(:last-child) {
  margin-bottom: measure(half);
}

.gift-card-container__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: measure(half);
  margin-top: 9rem;
}
</style>
